import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames/bind';
import {
  WhatsappShareButton,
  ViberShareButton,
  LineShareButton,
  EmailShareButton,
  WhatsappIcon,
  EmailIcon,
  ViberIcon,
  LineIcon,
} from 'react-share';

import IconMessenger from 'media/icons/messenger.icon.svg';
import styles from './SocialSharingList.module.scss';

const cx = classNames.bind(styles);

const SocialSharingList = ({ pageTitle, className }) => {
  const shareUrl = window.location.href;

  return (
    <div className={cx('root', className)}>
      <a
        className={cx('item', 'item-messanger')}
        href={`fb-messenger://share/?link=${pageTitle} ${shareUrl}`}
      >
        <IconMessenger className={cx('icon-messenger')} />
        <span className={'screen-reader'}>Send In Messenger</span>
      </a>

      <WhatsappShareButton
        url={shareUrl}
        title={pageTitle}
        separator=" "
        className={cx('item')}
      >
        <WhatsappIcon size={30} round />
      </WhatsappShareButton>

      <EmailShareButton
        url={shareUrl}
        subject={pageTitle}
        body={`${pageTitle} ${shareUrl}`}
        className={cx('item')}
      >
        <EmailIcon size={32} round />
      </EmailShareButton>

      <ViberShareButton
        url={shareUrl}
        title={pageTitle}
        separator={' '}
        className={cx('item')}
      >
        <ViberIcon size={28} round />
      </ViberShareButton>

      <LineShareButton url={shareUrl} title={pageTitle} className={cx('item')}>
        <LineIcon size={32} round />
      </LineShareButton>
    </div>
  );
};

SocialSharingList.propTypes = {
  className: string,
  pageTitle: string,
};

SocialSharingList.defaultProps = {
  className: null,
  pageTitle: null,
};

export default SocialSharingList;



// WEBPACK FOOTER //
// ./src/components/SocialSharingList/SocialSharingList.js